import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17dd0f02"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 正在加载... ")

import {
  ref,
  Ref,
  onDeactivated,
  onActivated,
  inject,
  watchEffect,
  computed,
  onMounted,
  watch
} from 'vue';
import {PullRefresh} from 'vant';
import {useRouter} from 'vue-router';
import InfoList from '@/components/InfoList.vue';
import FooterText from '@/components/FooterText.vue';
import {useAllList} from '@/service/info';
import useScrollList from '@/hooks/useScrollList';
import loadingGif from '@/assets/img/loading.gif';
import {haboClickReport} from '@/plugins/haboConfig';
import {useDeviceInfo} from '@/hooks/useDeviceInfo';
import {useTagInfo} from '@/hooks/useTagInfo';
import {TAB_KEY_MAP} from '@/enum/constant';


const __default__ = {
  name: 'TabContent',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    useNative: { type: Boolean },
    areaIdList: null,
    tabId: null,
    curActiveTab: null,
    ifRefetchTagList: null,
    tagListFinished: { type: Boolean },
    pushRenderedTab: null
  },
  setup(__props: any) {

const props = __props as {
  useNative: boolean;
  areaIdList: number[];
  tabId: number;
  curActiveTab: number;
  ifRefetchTagList:() => void;
  tagListFinished: boolean;
  pushRenderedTab: (tabId: number) => void;
}

_useCssVars(_ctx => ({
  "1e1951f4": (_unref(statusBarHeight))
}))



onMounted(() => {
  props.pushRenderedTab(props.tabId);
});

// 获取 url 上的 statusBarHeight  高度
const {statusBarHeight} = useDeviceInfo();
const isRec = computed(() => props.tabId === TAB_KEY_MAP.recommend);
const isCol = computed(() => props.tabId === TAB_KEY_MAP.collect);

// 记录当前 tab 下列表数据的地区 id, 默认为 0
const areaIdListDraft = ref<number[]>([0]);
// 当地区改变, 并且定位到当前 tab 时才重新请求
watchEffect(() => {
  if (props.tabId === props.curActiveTab) {
    areaIdListDraft.value = props.areaIdList;
  }
});

watch(areaIdListDraft, () => {
  firstPageRefetch({areaIdList: areaIdListDraft.value}).then(() => {
    isRefreshing.value = false;
  });
});

const topInfoRef = ref();

// 下拉刷新
const isRefreshing = ref<boolean>(false);
const pullRefresh = () => {
  firstPageRefetch().then(() => {
    isRefreshing.value = false;
  });
  props.ifRefetchTagList();
};

const router = useRouter();
const categoryId = +router.currentRoute.value.query.cmsCode! as number;
// active tag, tag list, 是否展示地区按钮
const {tagIdList} = useTagInfo();

// 请求全部列表数据
/* eslint-disable */
const {
  firstPageRefetch,
  firstPageError,
  firstPageFetching,
  firstPageFinished: listDataFinished,
  scrollBox,
  isLoading,
  listData,
} = useScrollList<
  InfoItem,
  {
    newsCategoryIds: number[];
    areaIdList: Ref<number[]>;
    h5TagIdList: number[];
    tagId: number | undefined;
    hasCollectQuery: 0 | 1;
  }
>({
  getListFunc: useAllList,
  params: {
    newsCategoryIds: [categoryId],
    areaIdList: areaIdListDraft,
    h5TagIdList: tagIdList,
    tagId: isCol.value || isRec.value ? 0 : props.tabId,
    hasCollectQuery: isCol.value ? 1 : 0, // 9999 请求收藏数据, enum 会报错
  },
  useNative: props.useNative
});
/* eslint-enable */
const firstPageFinished = computed(() => listDataFinished.value && props.tagListFinished);

const refetchFirstPageData = () => {
  firstPageRefetch();
  topInfoRef.value?.execute();
};


const handleRouteByBtn = inject('handleRouteByBtn') as (type: 'forward' | 'backward') => void;

const toDetail = (infoId: number, role: number) => {
  haboClickReport('INFO_ITEM_CLICK', {
    news_level: role,
    click_source: 2,
    news_id: infoId,
  });
  handleRouteByBtn('forward');
  const {query} = router.currentRoute.value;
  router.push({name: 'detail', params: {infoId}, query});

  // 手动已读置灰
  const index = listData.value.list.findIndex(
    (item: InfoItem) => item.informationId === infoId,
  );
  if (index !== -1) {
    // 一般来说列表里肯定有该项, 这里还是做一下容错
    listData.value.list[index].hasRead = true;
  }
};

// 缓存单个 tab 页定位
const scrollTop = ref<number>(0);
onActivated(() => {
  scrollBox!.value!.scrollTop = scrollTop.value;
});

onDeactivated(() => {
  scrollTop.value = scrollBox.value?.scrollTop as number;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "scrollBox",
    ref: scrollBox,
    class: "main-container"
  }, [
    _createVNode(_unref(PullRefresh), {
      modelValue: isRefreshing.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isRefreshing).value = $event)),
      "success-text": _unref(firstPageError) || topInfoRef.value?.error ? '刷新失败' : '刷新成功',
      class: "refresh-box",
      "head-height": "48",
      "pull-distance": "60",
      onRefresh: pullRefresh
    }, {
      loading: _withCtx(() => [
        _createElementVNode("img", {
          class: "loading-spin",
          src: _unref(loadingGif)
        }, null, 8, _hoisted_1),
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode(InfoList, {
          "first-page-fetching": _unref(firstPageFetching) || false,
          "first-page-finished": _unref(firstPageFinished),
          "info-list": _unref(listData)?.list || [],
          "first-page-error": _unref(firstPageError),
          "first-page-refetch": refetchFirstPageData,
          "to-detail": toDetail,
          "is-refreshing": isRefreshing.value,
          "if-refetch-tag-list": __props.ifRefetchTagList
        }, null, 8, ["first-page-fetching", "first-page-finished", "info-list", "first-page-error", "is-refreshing", "if-refetch-tag-list"]),
        (
          _unref(firstPageFinished) &&
            !_unref(firstPageFetching) &&
            !_unref(firstPageError) &&
            _unref(listData)?.list.length > 0
        )
          ? (_openBlock(), _createBlock(FooterText, {
              key: 0,
              "is-loading": _unref(isLoading),
              "list-length": _unref(listData)?.list.length
            }, null, 8, ["is-loading", "list-length"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "success-text"])
  ], 512))
}
}

})